export const configInvestments = [
  { id: 'movementType', header: 'Actividad' },
  { id: 'date', header: 'Fecha' },
  { id: 'amount', header: 'Monto' },
  { id: 'actions', header: '' }
]

export enum InvestmentStatus {
  ONBOARDING = 1,
  PENDING = 2,
  APPROVED = 3,
  SUSPENDED = 4,
  IN_PROGRESS = 5,
  INVERA_REVIEW = 6,
  CHANGES_REQUIRED = 7,
  ACCOUNT_CLOSED = 8,
  ACCOUNT_BLOCKED = 9,
  OPENING_REJECTED = 10,
  DRAFT_ACCOUNT = 11,
}

export enum InvestmentActionType {
  INVEST = 'Suscribir',
  RESCUE = 'Rescatar'
}
